import { render, staticRenderFns } from "./SearchLatest.vue?vue&type=template&id=f1e288a4"
import script from "./SearchLatest.vue?vue&type=script&lang=js"
export * from "./SearchLatest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports